import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import TableClasses from "Components/TableLoad";

import { FiPlus } from "react-icons/fi";
import { IoPencil } from "react-icons/io5";
import { MdDelete } from "react-icons/md";

import ImagePreview from "Components/ImagePreview";
import Moment from "react-moment";
import {
    showErrorAlert,
    showWarningAlert,
    confirmAction,
    Toast,
} from "Util/Alerts";
import { useSearchParams } from "react-router-dom";

import { giveawayproductsType } from "./Types";

import {
    Get_giveawayproducts,
    Delete_giveawayproducts,
} from "Services/Requests";
// import {  } from "Util/Alerts";
import Styles from "Styles/Styles.module.css";
import ReactPaginate from "react-paginate";

function GiveawayproductsComp() {
    const Navigate = useNavigate();
    let TableHead = [
        "SNO",
        "PRODUCT IMAGE",
        "PRODUCT",
        "CREATED ON",
        "ACTIONS",
    ];
    const [giveawayproducts, setgiveawayproducts] = useState<
        giveawayproductsType[]
    >([]);
    const [searchParams, setSearchParams] = useSearchParams();

    const [loading, setLoading] = useState<boolean>(true);
    // State to handle modal visibility and the selected image
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [Count, setCount] = useState(0);
    const [forcepage, setfocrcepage] = useState(0);
    const [showPaginate, setShowPaginate] = useState(false);

    const getgiveawayproducts = async (page: any) => {
        try {
            const response = await Get_giveawayproducts(page);
            if (response?.data?.status === 1) {
                setgiveawayproducts(response?.data?.giveaways);
                setCount(response?.data?.pageCount);
                if (response?.data?.pageCount > 1) {
                    setShowPaginate(true);
                }
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    const Deletegiveawayproducts = async (id: any) => {
        setLoading(true);
        try {
            const response = await Delete_giveawayproducts(id);
            if (response?.data?.status === 1) {
                Toast("giveawayproduct Deleted Successfully", "success");

                getgiveawayproducts(1);
            } else {
                setLoading(false);
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            setLoading(false);
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        }
    };

    useEffect(() => {
        let page = searchParams.get("page") ?? 1;

        setSearchParams({
            page: page.toString(),
        });

        setfocrcepage(Number(page) - 1);
        getgiveawayproducts(page);
    }, []);

    // Function to handle image click and show the modal
    const handleImageClick = (imageUrl: string) => {
        setSelectedImage(imageUrl);
        setIsModalVisible(true);
    };

    // Function to close the modal
    const handleCancel = () => {
        setIsModalVisible(false);
        setSelectedImage(null);
    };

    const deleteHandler = (item: giveawayproductsType) => {
        confirmAction(
            "Warning",
            "Are you sure you want to Delete giveawayproduct?",
            () => Deletegiveawayproducts(item.giveaway_product_id),
            "Delete"
        );
    };
    const handlePageChange = (selectedObject: any) => {
        setSearchParams({
            page: selectedObject.selected + 1,
        });
        setfocrcepage(selectedObject.selected);
        getgiveawayproducts(selectedObject.selected + 1);
        window.scrollTo({ top: 10, behavior: "smooth" });
    };
    return (
        <div className={Styles["Container"]}>
            <ImagePreview
                handleCancel={handleCancel}
                isModalVisible={isModalVisible}
                selectedImage={selectedImage}
                title="giveawayproducts"
            />
            <header>
                <h3>Prizes</h3>
                <button
                    className={Styles["Add_cat_btn"]}
                    onClick={() => Navigate("/auth/give-away-products/add")}>
                    <FiPlus />
                    Add Prize
                </button>
            </header>
            {loading ? (
                <TableClasses TableHead={TableHead} />
            ) : (
                <div className={Styles["tableWrapper"]}>
                    <table>
                        <thead>
                            {TableHead.map((item) => (
                                <th>{item}</th>
                            ))}
                        </thead>
                        <tbody>
                            {giveawayproducts.length > 0 ? (
                                giveawayproducts?.map((item) => (
                                    <tr key={item?.giveaway_product_id}>
                                        <td>{item?.sNo}</td>
                                        <td
                                            onClick={() =>
                                                handleImageClick(item.image_url)
                                            }>
                                            <div className={Styles["banner"]}>
                                                <img
                                                    src={item.image_url}
                                                    alt="giveawayproducts"
                                                />
                                            </div>
                                        </td>{" "}
                                        <td> {item.giveaway_product_name}</td>
                                        <td>
                                            <Moment format="DD-MM-YYYY" utc>
                                                {item.created_at}
                                            </Moment>
                                        </td>
                                        <td>
                                            <div
                                                className={
                                                    Styles["Action_Tabs"]
                                                }>
                                                <button
                                                    onClick={() =>
                                                        Navigate(
                                                            "/auth/give-away-products/edit",
                                                            { state: item }
                                                        )
                                                    }>
                                                    <IoPencil size={24} />
                                                </button>

                                                <button
                                                    onClick={() =>
                                                        deleteHandler(item)
                                                    }>
                                                    <MdDelete size={22} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={TableHead.length}>
                                        No Giveaway products Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {showPaginate && (
                        <ReactPaginate
                            pageCount={Count}
                            // pageRange={2}
                            forcePage={forcepage}
                            marginPagesDisplayed={2}
                            onPageChange={handlePageChange}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            containerClassName={"pagination"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            activeClassName={"active"}
                        />
                    )}
                </div>
            )}
        </div>
    );
}

export default GiveawayproductsComp;
